import React, { useContext, useState } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'

import {
  deleteBidOfferMarginAnalysis,
  getBidOfferMarginAnalysis,
  updateBidOfferMarginAnalysis,
} from 'api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import { DatePickerContext, PNodeZoneContext } from 'context'
import { unitIdHeader } from 'core/HeaderColTypeProps'

import CommonScreen from 'admin/component/CommonScreen'

const title = 'Bid Offer'

const TalenBidOffer = () => {
  const { selectedDate } = useContext(DatePickerContext)

  // eslint-disable-next-line no-unused-vars
  const [insertEvent, setInsertEvent] = useState(false)
  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    // marginUnitsList,
    emktUnits,
  } = useContext(PNodeZoneContext)

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDate,
    enddate: selectedDate,
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: emktUnits,
    units: emktUnits,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaBidOfferHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  return (
    <CommonScreen
      // extraCriteriaAfterButton={extraCriteriaAfterButton}
      // extraCriteria={extraCriteriaAfterButton}
      extraUnitSelectionProps={extraUnitSelectionProps}
      withDatePicker
      withCriteria={withCriteria}
      withUnitSelection
      title={title}
      header={headerWithFormatter}
      retrieveTask={getBidOfferMarginAnalysis}
      deleteTask={deleteBidOfferMarginAnalysis}
      saveTask={updateBidOfferMarginAnalysis}
      altBy={d => d.unitid}
      autoRetrieve={false}
      sortOptions={OaBidOfferHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      allowInsert={false}
      withoutModify
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(TalenBidOffer)

export const OaBidOfferHeaders = [
  // strCol({ ident: 'companyId', display: 'CompanyId', isFiltered: true }),
  // strCol({ ident: 'unitid', display: 'Unit', isKey: true }),
  unitIdHeader,
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    sortOrder: 'asc',
  }),

  intCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'slope',
    display: 'Slope',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'mw', display: 'MW', isKey: true, sortOrder: 'asc' }),
  numCol({
    ident: 'price',
    display: 'Price',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'modifier',
    display: 'Modifier',
    showInRowEditor: false,
    type: 'str',
    width: 130,
    isKey: true,
  }),
  {
    ident: 'modifiedDate',
    display: 'Modified Date',
    width: 200,
    showInRowEditor: false,
    dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    displayFormat: 'MM/DD/YYYY HH:mm:SS',
    type: 'date-time',
    isKey: true,
  },
]
